import { memo } from "react";
import { Table } from "antd";
import { PillPagination } from "../PillPagination";



function MilestoneTableComponent({
  milestoneColumns,
  filteredMilestones,
  loadingData,
  milestonePage,
  milestonePageSize,
  totalCount,
  onPageChange,
}) {
  return (
    <>
      <Table
        columns={milestoneColumns}
        dataSource={filteredMilestones}
        loading={loadingData}
        rowKey={(r) => r.milestoneId || `${r.projectId}-${r.sowId}-${r.milestoneName}`}
        size="small"
        style={{ minHeight: 400 }}
        pagination={false}
      />
      <PillPagination
        currentPage={milestonePage}
        pageSize={milestonePageSize}
        total={totalCount}
        itemLabel="records"
        onPageChange={(page) => onPageChange(page)}
        pageSizeOptions={[10, 20, 50, 100]}
        onPageSizeChange={(size) => onPageChange(1, size)}
      />
    </>
  );
}

export const MilestoneTable = memo(MilestoneTableComponent);